(function () {
    'use strict';
    angular.module('Services').service('TransitWarrantyProvidersTableService', TransitWarrantyProvidersTableService);
    TransitWarrantyProvidersTableService.$inject = [
        'TransitWarrantyService',
        'TableLiteFactory',
        'toastr',
        '$filter',
        '$uibModal',
        '$rootScope'
    ];

    function TransitWarrantyProvidersTableService(
        TransitWarrantyService,
        TableLiteFactory,
        toastr,
        $filter,
        $uibModal,
        $rootScope
    ) {
        return function (defaultFilters = {}) {
            const vm = this;
            const tableStructure = {
                tableName: 'TransitWarrantyProvidersTableService',
                config: {},
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add Insurance Providers',
                        tooltip: 'Click to create a new rate',
                        onClick: () => {
                            showTransitWarrantyProviderModal()
                        }
                    }]
                },
                headers: [
                    {
                        label: 'Providers Name',
                        viewName: 'name',

                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Enabled',
                        viewName: 'status',

                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Actions',
                        viewName: 'actions'
                    }
                ],
                data: []
            }


            getMappingData($rootScope.GlobalProfile.company.id)

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: TransitWarrantyService.providers.getAll, // need api 
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: res => {
                    const data = {};
                    data.content = res;
                    buildTableData(data);
                },
                postRequestErrorCallback: error => {
                    buildTableData(null);
                    toastr.error(error);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc',
                    // reseller_id: $rootScope.GlobalProfile.company.id
                }
            });

            function getMappingData(id) {
                TransitWarrantyService.providers.getMappingProvider(id,
                    res => {
                        vm.providerMapIds = res;
                    },
                    err => {
                        toastr.error(err.message)
                    }
                )
            }

            function buildTableData(data) {
                // tableActions.initializeTableData(data);
                // data.content = []
                angular.forEach(data.content, row => {

                    row.name = row.name;
                    row.status = {
                        type: 'status',
                        status: row.status,
                        label: row.status ? 'Yes' : 'No'
                    };
                    row.actions = {
                        type: 'button',
                        buttons: [
                            {
                                text: 'View',
                                class: 'btn-success',
                                action: data => {
                                    showTransitWarrantyProviderModal(data)
                                }
                            }
                        ]
                    };
                    tableStructure.data.push(row);
                });
            }

            function showTransitWarrantyProviderModal(data) {
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/transit-warranty/modal/transit-warranty-providers-details-modal.html',
                    controller: 'TransitWarrantyProviderDetails',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        provider: () => data,

                    }
                });

                modalInstance.result.then(() => {
                    tableActions.sendRequest({})
                });
            }

            this.tableData = tableStructure;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/transit-warranty/TransitWarrantyProvidersTableService.js